import React from 'react'
// import { Container } from './style'
import Dashboard from '../../components/Dashboard'
// import Map from '../../components/Maps/GoogleMap/Basic'
// import { googleData } from '../../data/map'

export default ({ path }) => (
  <Dashboard />
)